import clsx from 'clsx'
import BasicButtonLink from 'shared-components/buttons/BasicButtonLink'
import AppImage from 'shared-components/ui/AppImage'
import Score from 'shared-components/ui/Score'
import ScoreRing from 'shared-components/ui/ScoreRing'
import { BasicStyledComponent, DSReviewProductPart } from 'shared-definitions/types'
import styles from './BadgedProductShort.module.css'

interface BadgedProductShortProps extends BasicStyledComponent {
  review: Pick<DSReviewProductPart, 'storeButton' | 'bottomLineContent' | 'device' | 'badges'>
}

const BadgedProductShort: React.VFC<BadgedProductShortProps> = ({
  className,
  review: { badges, storeButton, bottomLineContent, device },
}) => {
  const [badge] = badges
  return (
    <div className={clsx(styles.container, className, { [styles.hasBadge]: badge !== undefined })}>
      {badge ? (
        <AppImage
          image={badge}
          imageClassName={styles.badgeImage}
          layout="raw"
          sizes={76}
          className={styles.badge}
        />
      ) : null}
      <div className={clsx(styles.titleBlock, { [styles.hasScore]: device.ourScore !== null })}>
        {device.ourScore ? (
          <ScoreRing className={styles.scoreRing} score={device.ourScore} />
        ) : null}
        <div className={styles.title}>{device.name}</div>
        {device.ourScore ? <Score className={styles.score} score={device.ourScore} /> : null}
      </div>
      {storeButton ? (
        <div className={styles.buttonBlock}>
          <div className={styles.storeTitle}>{storeButton.store}</div>
          <BasicButtonLink className={styles.storeButton} {...storeButton.link.pLink}>
            {storeButton.link.label}
          </BasicButtonLink>
        </div>
      ) : null}
      <div className={styles.bottomBlock}>
        <div className={styles.bottomTitle}>{bottomLineContent.title}</div>
        <div className={styles.bottomText}>{bottomLineContent.text}</div>
      </div>
    </div>
  )
}

export default BadgedProductShort
